<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-wrapper">
        <!-- 左侧导航 -->
        <div class="footer-nav">
          <div style="text-align: left;">
            <h2 class="nav-title">关于我们</h2>
            <div class="nav-links-row">
              <router-link 
                v-for="(item, index) in navItems" 
                :key="item.name"
                :to="item.path"
                class="nav-link"
              >{{ item.name }}<i
                  v-if="index < navItems.length - 1" class="nav-sep"></i></router-link>
            </div>
          </div>
        </div>

        <!-- 右侧联系信息 -->
        <div class="footer-info">
          <img src="../assets/ewm.jpg" alt="">
          <div>
            <p>地址：北京市朝阳区常营星座3栋603</p>
            <p>电话：010-53604735</p>
            <p>客服电话：400-966-5938</p>
            <p>邮箱：bjyxjh@188.com</p>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="copyright">©2026 北京悦享聚汇科技有限公司 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" >京ICP备2021014997号-2</a>  </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { Index } from '../api/login';
export default {
  name: 'AppFooter',
  data () {
    return {info:'',
      navItems: [
        { name: '福利优选', path: '/service' },
        { name: '年节礼包', path: '/news' },
        { name: '生日卡券', path: '/service' },
        { name: '电影演出', path: '/cases' },
        { name: '悦动态', path: '/contact' }
      ]
    }
  },
  methods: {
    async Index(){
      const res = await Index();
      console.log(res)
      this.info=res.data.company;
    },
    scrollProducts(direction) {
      const slider = this.$refs.productsSlider
      const scrollAmount = 297
      slider.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      })
    }
  },
  mounted() {
     
    this.Index();
  }
}
</script>

<style scoped>
.footer {
  background: #2c2c2c;
  padding: 40px 0 20px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.footer-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}
.nav-title {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}
.nav-links-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.nav-link {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s;
  white-space: nowrap;
  text-decoration: none;
}
.nav-link:hover {
  color: #fff;
}
.nav-sep {
  display: inline-block;
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 15px;
  vertical-align: middle;
}
.footer-info {
  display: flex;
  text-align: right;
  line-height: 28px;
}
.footer-info img {
  margin-right: 20px;
  width: 100px;
  height: 100px;
  
  margin-top: 6px;
}
.footer-info p {
  color: #c6c6c6;
  font-size: 14px;
  margin: 0;
}
.footer-bottom {
  margin-top: 30px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  
}
.footer-bottom  a{color: #999999;text-decoration: none;}
.copyright {
  color: #999;
  font-size: 13px;
}

@media (max-width: 768px) {
  .footer-wrapper {
    flex-direction: column;
    gap: 20px;
  }
  .footer-info {
    text-align: center;
  }
  .footer-bottom {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/foot.vue